import { render, staticRenderFns } from "./TCookiesDialog.vue?vue&type=template&id=ee2811da&scoped=true&"
import script from "./TCookiesDialog.vue?vue&type=script&lang=ts&"
export * from "./TCookiesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./TCookiesDialog.vue?vue&type=style&index=0&id=ee2811da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2811da",
  null
  
)

export default component.exports